/**
 * Contains the key to a langauge string along with any parameters that should be used with it.
 * e.g.
 * new LangString('CUSTOMER_DETAILS.MORE_CONTACTS', { count: 17 });
 */
class LangString {
    /**
     * @type {string}
     */
    key;

    /**
     * @type {object}
     */
    params = {};

    constructor(key, params = {}) {
        this.key = key;
        this.params = params;
    }
}

module.exports = LangString;
